



import { Diamond } from "@mui/icons-material";
import { useEffect } from "react";

// Define field key mappings
const fieldKeysMapping = {
  common: [
    "CategoryId", "ProductId", "DesignId", "PurityId", "CollectionId",
    "PacketId", "BoxId", "mainstone", "WeightCategory", "Quantity",
    "TotalWeight", "PackingWeight", "GrossWt", "TotalStoneWeight", "NetWt",
    "Pieces", "MakingPercentage", "MakingPerGram", "MakingFixedAmt", "MRP",
    "ClipWeight", "images", "ProductName", "Description", "Gender",
    "Stones", "importbtn",
    "VendorId", "SKU", "ItemCode", "RFIDCode", "TIDNumber",
    "Size", "ClipQuantity", "ProductTitle", "ProductCode", "HUIDCode",
    "HallmarkAmount", "TotalStoneAmount", "OtherWeight", "PouchWeight",
    "TagWeight", "FindingWeight", "LanyardWeight", "OccassionName",
    "Status", "Featured","ActionPlus","IButton"
  ],
  commondiamond: [
    "CategoryId", "ProductId", "DesignId", "PurityId", "CollectionId",
    "PacketId", "BoxId", "mainstone", "WeightCategory", "Quantity",
    "TotalWeight", "PackingWeight", "GrossWt", "TotalStoneWeight", "NetWt",
    "Pieces", "MakingPercentage", "MakingPerGram", "MakingFixedAmt", "MRP",
    "ClipWeight", "images", "ProductName", "Description", "Gender",
    "Stones", "DButton", "importbtn",
    "VendorId", "SKU", "ItemCode", "RFIDCode", "TIDNumber",
    "Size", "ClipQuantity", "ProductTitle", "ProductCode", "HUIDCode",
    "HallmarkAmount", "TotalStoneAmount", "OtherWeight", "PouchWeight",
    "TagWeight", "FindingWeight", "LanyardWeight", "OccassionName",
    "Status", "Featured","ActionPlus","IButton"
  ],
  commonunlabel: [
    "CategoryId", "ProductId", "DesignId", "PurityId", "CollectionId",
    "PacketId", "BoxId", "mainstone", "WeightCategory", "Quantity",
    "TotalWeight", "PackingWeight", "GrossWt", "TotalStoneWeight", "NetWt",
    "Pieces", "MakingPercentage", "MakingPerGram", "MakingFixedAmt", "MRP",
    "ClipWeight", "images", "ProductName", "Description", "Gender",
    "Stones", "DButton", "importbtn", "FinePercent", "WastagePercent", "FineWastage"
  ],
  looseDiamond: [
    "CategoryId", "PacketId", "BoxId", "Pieces", "images", "DiamondShape",
    "DiamondClarity", "DiamondColour", "DiamondSize", "DiamondSleve",
    "DiamondWeight", "DiamondSellRate", "DiamondPieces", "DiamondCut",
    "DiamondSettingType", "DiamondCertificate", "ActionPlus"
  ],
  looseStones: [
    "CategoryId", "PacketId", "BoxId", "Pieces", "images", "StoneName",
    "StoneColor", "StoneShape", "StoneSize", "StoneWeight", "StonePieces",
    "StoneRatePiece", "StoneRateKarate", "StoneAmount", "StoneDescription",
    "StoneCertificate", "StoneSettingType", "ActionPlus"
  ],
};

const updateFieldVisibility = (fields, fieldKeys, visibility, isOnlineFieldEnabled) => {
  return fields.map((field) => {
    if (
      fieldKeys.includes(field.key) &&
      (field.place === "middle" || field.place === "grid") &&
      isOnlineFieldEnabled(field.key, field.place)
    ) {
      return {
        ...field,
        visibility: visibility,
      };
    } else if (field.place === "middle" || field.place === "grid") {
      return {
        ...field,
        visibility: "Hidden",
      };
    }
    return field;
  });
};

const getFieldKeysByCategoryold = (categoryName, StockType) => {


  if (categoryName === "LOOSE DIAMOND") return fieldKeysMapping.looseDiamond;
  if (categoryName === "LOOSE STONES") return fieldKeysMapping.looseStones;
  
  if (categoryName !== "LOOSE STONES" && categoryName !== "LOOSE DIAMOND" && categoryName.includes('DIAMOND') && StockType === 'Labelled') return fieldKeysMapping.commondiamond;
  if (categoryName !== "LOOSE STONES" && categoryName !== "LOOSE DIAMOND" && StockType === 'Labelled') return fieldKeysMapping.common;
  if (categoryName !== "LOOSE STONES" && categoryName !== "LOOSE DIAMOND" && StockType === 'UnLabelled') return fieldKeysMapping.commonunlabel;
  
  console.log('checking filterfields ', categoryName, '   ', StockType);

  return fieldKeysMapping.common;
};


const getFieldKeysByCategory = (categoryName, StockType) => {
  // Ensure categoryName is valid before performing any operations
  if (!categoryName) {
    console.warn('categoryName is null or undefined:', categoryName);
    return fieldKeysMapping.common; // Return a default value or handle appropriately
  }

  if (categoryName === "LOOSE DIAMOND") return fieldKeysMapping.looseDiamond;
  if (categoryName === "LOOSE STONES") return fieldKeysMapping.looseStones;

  if (
    categoryName !== "LOOSE STONES" && 
    categoryName !== "LOOSE DIAMOND" && 
    categoryName.includes('DIAMOND') && 
    StockType === 'Labelled'
  ) {
    return fieldKeysMapping.commondiamond;
  }
  
  if (
    categoryName !== "LOOSE STONES" && 
    categoryName !== "LOOSE DIAMOND" && 
    StockType === 'Labelled'
  ) {
    return fieldKeysMapping.common;
  }
  
  if (
    categoryName !== "LOOSE STONES" && 
    categoryName !== "LOOSE DIAMOND" && 
    StockType === 'UnLabelled'
  ) {
    return fieldKeysMapping.commonunlabel;
  }
  
  console.log('checking filterfields ', categoryName, '   ', StockType);

  return fieldKeysMapping.common;
};


const getCategoryNameById = (categoryId, categoriesData) => {
  return categoriesData.find((v) => v.Id === parseInt(categoryId))?.CategoryName || null;
};

const isOnlineFieldEnabled = (fieldKey, fieldPlace, apifieldsControls) => {
  const matchingApiField = apifieldsControls.find(
    (apiField) => apiField.key === fieldKey && apiField.place === fieldPlace
  );
  // if(fieldKey == "DButton"){
  console.log('useeffect matched', matchingApiField);
  // }
  return matchingApiField?.visibility === "ReadWrite";
};

const useStockTypeEffect = (StockType, itemfields, setItemfields, categoriesData, apifieldsControls, selectedcategory) => {
  useEffect(() => {


    if (StockType || selectedcategory) {
      const categoryField = itemfields.find(
        (item) => item.key === "CategoryId" && item.place === "middle"
      );

      if (!categoryField?.value) {
        // No category selected, show common fields
        if (StockType === 'UnLabelled') {
          setItemfields((prevFields) =>
            updateFieldVisibility(
              prevFields,
              fieldKeysMapping.commonunlabel,
              "ReadWrite",
              (key, place) => isOnlineFieldEnabled(key, place, apifieldsControls)
            )
          );
        }
        else {
          const categoryName = getCategoryNameById(categoryField.value, categoriesData);
          const fieldKeys = getFieldKeysByCategory(categoryName, StockType);



          setItemfields((prevFields) =>
            updateFieldVisibility(
              prevFields,
              fieldKeys,
              "ReadWrite",
              (key, place) => isOnlineFieldEnabled(key, place, apifieldsControls)
            )
          );
        }

      } else {
        const categoryName = getCategoryNameById(categoryField.value, categoriesData);
        const fieldKeys = getFieldKeysByCategory(categoryName, StockType);

        
        

        setItemfields((prevFields) =>
          updateFieldVisibility(
            prevFields,
            fieldKeys,
            "ReadWrite",
            (key, place) => isOnlineFieldEnabled(key, place, apifieldsControls)
          )
        );
      }
    } else {
      // Handle other StockTypes
      setItemfields((prevFields) =>
        updateFieldVisibility(
          prevFields,
          [...fieldKeysMapping.common, "Stones", "images"],
          "ReadWrite",
          (key, place) => isOnlineFieldEnabled(key, place, apifieldsControls)
        )
      );
    }
  }, [StockType, categoriesData, selectedcategory]);
};

export default useStockTypeEffect;

